import { printedGlName } from '@/utils/dues-period';

/** The fields of an invoice line the Description column is built from. */
export interface InvoiceLineText {
	memo?: string | null;
	category: string;
	glCodeName?: string | null;
}

/**
 * Each invoice line's Description: its memo (else its category), plus its GL account's name
 * when another line on the same invoice would otherwise read identically. Dues split across GL
 * lines used to be posted with one memo for every line, so a $44 Capital Reserve line and a $196
 * Operating line both printed "… Association Fee · 2027-01" — the GL name is what tells them
 * apart. A memo that already names its GL is left alone.
 */
export const invoiceLineDescriptions = (lines: InvoiceLineText[]): string[] => {
	const base = lines.map((l) => l.memo?.trim() || l.category);
	const counts = new Map<string, number>();
	for (const text of base) counts.set(text, (counts.get(text) ?? 0) + 1);
	return lines.map((l, i) => {
		const gl = l.glCodeName?.trim();
		if (!gl || (counts.get(base[i]) ?? 0) < 2 || base[i].toLowerCase().includes(gl.toLowerCase())) return base[i];
		return `${base[i]} · ${printedGlName(gl)}`;
	});
};
